import React from "react";

const SelectFieldset = ({ data, value, onInputChange }) => {
    const { inputKey, options, required, label } = data;

    return (
        <fieldset className="border border-light-grey-color w-full h-12 rounded-md">
            <legend className="mx-3 px-1 text-xs">
                {label} {required ? "*" : ""}
            </legend>

            <div className="flex flex-row justify-start items-center pl-2 pr-3">
                <select
                    name={inputKey}
                    onChange={onInputChange}
                    value={value ?? ""}
                    className="focus:ring-blue-500 focus:border-blue-500 dark:bg-white dark:border-gray-600 dark:placeholder-gray-400 dark:text-[#47556980] dark:focus:ring-blue-500 dark:focus:border-blue-500 border-0 text-Default text-opacity-50 text-sm bg-white w-full focus:outline-none hover:border-black placeholder:text-PH_Default placeholder:text-sm rounded-md px-2"
                >
                    <option value="" disabled className="text-gray-400">
                        Select {label}
                    </option>
                    {options.map((option) => (
                        <option key={option.value} value={option.value} className="text-sm">
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </fieldset>
    );
};

export default SelectFieldset;
